import posthog from 'posthog-js';

export const initPostHog = () => {
    const apiKey = import.meta.env.VITE_APP_POSTHOG_KEY;
    const apiHost = import.meta.env.VITE_APP_POSTHOG_HOST || 'https://app.posthog.com';

    if (apiKey) {
        posthog.init(apiKey, {
            api_host: apiHost,
            enable_recording_console_log: true,
            autocapture: true,
            capture_pageview: true,
            disable_session_recording: false,
            capture_exceptions: true,
        });

        window.addEventListener('unhandledrejection', (event) => {
            posthog.capture('$exception', {
                $exception_message: event.reason?.message || String(event.reason),
                $exception_stack: event.reason?.stack,
                $exception_type: 'unhandled_promise_rejection',
            });
        });
    } else {
        console.warn('PostHog API key not found. Interactions will not be tracked.');
    }
};

export default posthog;
